export interface Size {
  width: number
  height: number
}

export interface Point {
  x: number
  y: number
}

export const getViewportSize = (): Size => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  }
}

export const scrollToTarget = (scrollContainer: HTMLElement, targetElement: HTMLElement) => {
  const containerRect = scrollContainer.getBoundingClientRect()
  const targetRect = targetElement.getBoundingClientRect()

  const relativeTop = targetRect.top - containerRect.top + scrollContainer.scrollTop
  const maxScrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight
  const targetScrollTop = Math.min(relativeTop, maxScrollTop)

  scrollContainer.scrollTo({
    top: targetScrollTop,
    behavior: 'smooth',
  })
}
